// extracted by mini-css-extract-plugin
export default {"heading":"KUtV4F2sFK3ztP7RiEVq","container":"d7MRjDTU4GyoScdhuzKZ","spinnerContainer":"vQkHvzGLHaHKhSos60V7","packageContainer":"k4OyCHQea9YI5FDUNHap"};